/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './subscription-billing.reducer';

export const SubscriptionBillingDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const subscriptionBillingEntity = useAppSelector(state => state.subscriptionBilling.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="subscriptionBillingDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.subscriptionBilling.detail.title">SubscriptionBilling</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.id">Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.id}</dd>
          <dt>
            <span id="firstName">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.firstName">First Name</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.firstName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.lastName}</dd>
          <dt>
            <span id="customerId">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.customerId">Customer Id</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.customerId}</dd>
          <dt>
            <span id="validTill">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.validTill">Valid Till</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.validTill}</dd>
          <dt>
            <span id="remindFrom">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.remindFrom">Remind From</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.remindFrom}</dd>
          <dt>
            <span id="lockOutOn">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.lockOutOn">Lock Out On</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.lockOutOn}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.active">Active</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.subscriptionBilling.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{subscriptionBillingEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.subscriptionBilling.payment">Payment</Translate>
          </dt>
          <dd>{subscriptionBillingEntity.payment ? subscriptionBillingEntity.payment.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.subscriptionBilling.contactDetails">Contact Details</Translate>
          </dt>
          <dd>{subscriptionBillingEntity.contactDetails ? subscriptionBillingEntity.contactDetails.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/subscription-billing" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/subscription-billing/${subscriptionBillingEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubscriptionBillingDetail;
